<template>
 
   <el-select v-model="value" clearable v-on:change="selectChange" :placeholder="placeholder">
    <el-option
      v-for="item in items"
      :key="item.value"
      :label="item.Extend1"
      :value="item.ItemKey">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "ZJComponent-Dropdown",
  props: {
    syscode: {
      required: true,
      default: ""
    },
    ukey: {
      required: true,
      default: ""
    },
    path: String,
    placeholder:{
      type:String,
      default:"全部"
    }
  },
  data() {
    return {
      items: [],
      value:''
    };
  },
  mounted() {
    this.draw();
  },
  computed: {
    configKey: function() {
      var result = this.syscode + ":" + this.ukey;
      if (this.path) {
        result += ":" + this.path;
      }
      return result;
    }
  },
  methods: {
    draw: function() {
      this.config
        .getUValue(this.configKey, "")
        .then(d => {
          this.items = d.JValue;
        })
        .catch(e => console.error(e));
    },
    selectChange:function(selectValue){
      this.$emit("onSelectChange",selectValue);
    }
  }
};
</script>